export class GridChartRegistry {
    static instances = new Map();
    static register(id, handle) {
        this.instances.set(id, handle);
    }
    static unregister(id) {
        this.instances.delete(id);
    }
    static get(id) {
        return this.instances.get(id);
    }
    static getAll() {
        return Array.from(this.instances.values());
    }
    static clear() {
        this.instances.clear();
    }
}
